/* ================================
   FEATURE FLAGS
================================ */

// Uma flag só desliga com "false" explícito na env.
// Env ausente = ligada, então dev/hml/local seguem completos
// sem nenhuma configuração nova no Amplify.
// CRA inlina REACT_APP_* no build: mudar flag exige rebuild.
const isEnabled = (value: string | undefined): boolean => value !== "false";

export const featureFlags = {
  /** Sales + Payment + Delivery: checkout, pedidos, vendas, relatórios */
  checkout: isEnabled(process.env.REACT_APP_FEATURE_CHECKOUT),

  /** Sales (coupons): cupons públicos e do lojista */
  coupons: isEnabled(process.env.REACT_APP_FEATURE_COUPONS),

  /** Notification: sino e página de notificações */
  notifications: isEnabled(process.env.REACT_APP_FEATURE_NOTIFICATIONS),

  /**
   * Simula a resposta de POST /orders (sem chamar a API real) para
   * visualizar as telas de pix/boleto. Opt-in: só liga com "true"
   * explícito na env, então nunca ativa por acidente em prod.
   */
  mockCheckoutResponse: process.env.REACT_APP_MOCK_CHECKOUT === "true",
} as const;
